const userRoleAndPermission = require('../../config/userPermisionNew.json');

export class AllowedTeamWizeRolesConfig {
    constructor() {
        this.roles = userRoleAndPermission ? userRoleAndPermission?.userRole : {};
        this.teams = userRoleAndPermission ? userRoleAndPermission?.teams : [];

    }

    createPermissions(actions = ['edit', 'view']) {

        const permissionObject = {};
        actions.forEach(action => {
            permissionObject[action] = {};

            this.teams.forEach(team => {
                const teamKey = `${team}`;
                const attributeKey = `${team}Attribute`;

                permissionObject[action][attributeKey] = [
                    ...(this.roles[teamKey] || []),
                    ...(this.roles.adminTeamRole || []),
                ];
            });
        });

        return permissionObject;
    }

    // authorizePermission(user, teamWizeRoleEligibility, team, action) {
    //     return !user.rolesAssigned.find(
    //         (role) =>
    //             teamWizeRoleEligibility[`${action}`][`${team}Attribute`]?.includes(
    //                 role
    //             ) ||
    //             teamWizeRoleEligibility?.edit?.planningAttribute?.includes(
    //                 role
    //             )
    //     )
    // }



}


